export enum ReliabilityAfterPoolVendorType {
  Oem = 1,
  RepairStation = 2,
  TtShop = 3,
}

export const ReliabilityAfterPoolVendorTypeChoices = [
  { key: "OEM", value: ReliabilityAfterPoolVendorType.Oem },
  { key: "REPAIR STATION", value: ReliabilityAfterPoolVendorType.RepairStation },
  { key: "TT SHOP", value: ReliabilityAfterPoolVendorType.TtShop },
];
